package ai.wagemix.logic.jobdescriptions

/** A job board the API can read a posting from. */
data class WMJobBoard(val domain: String, val displayName: String)

enum class WMUrlProblem { Blank, Malformed, UnsupportedBoard }

/** The job-board allow-list and the URL rule, shared by the presenter and the help text. */
object WMJobBoards {
    val SUPPORTED: List<WMJobBoard> = listOf(
        WMJobBoard("lever.co", "Lever"),
        WMJobBoard("myworkdayjobs.com", "Workday"),
        WMJobBoard("icims.com", "iCIMS"),
        WMJobBoard("smartrecruiters.com", "SmartRecruiters"),
        WMJobBoard("bamboohr.com", "BambooHR"),
        WMJobBoard("jazzhr.com", "JazzHR"),
        WMJobBoard("adp.com", "ADP"),
        WMJobBoard("jobvite.com", "Jobvite"),
        WMJobBoard("greenhouse.io", "Greenhouse")
    )

    /** The board a URL belongs to: an exact host match or a subdomain of a supported domain. */
    fun boardOf(url: String): WMJobBoard? {
        val host = hostnameOf(url)?.lowercase() ?: return null
        return SUPPORTED.firstOrNull { board -> host == board.domain || host.endsWith(".${board.domain}") }
    }

    fun problemOf(url: String): WMUrlProblem? = when {
        url.isBlank() -> WMUrlProblem.Blank
        hostnameOf(url) == null -> WMUrlProblem.Malformed
        boardOf(url) == null -> WMUrlProblem.UnsupportedBoard
        else -> null
    }

    /** Adds a scheme when missing and returns the host, or `null` when there is none. */
    fun hostnameOf(url: String): String? {
        val trimmed = url.trim()
        if (trimmed.isEmpty() || trimmed.any { it.isWhitespace() }) return null
        val withScheme = if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) trimmed else "https://$trimmed"
        val afterScheme = withScheme.substringAfter("://")
        val authority = afterScheme.takeWhile { it != '/' && it != '?' && it != '#' }
        val host = authority.substringAfterLast('@').substringBefore(':')
        return host.takeIf { it.isNotEmpty() && it.contains('.') && it.all { c -> c.isLetterOrDigit() || c == '-' || c == '.' } }
    }
}
